import { render, staticRenderFns } from "./editFrom.vue?vue&type=template&id=5a30bf04&"
import script from "./editFrom.vue?vue&type=script&lang=js&"
export * from "./editFrom.vue?vue&type=script&lang=js&"
import style0 from "./editFrom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports